module.exports = "<button class=\"btn btn-{{color}} ripple shadow\" [ngClass]=\"{'btn-coti': coti, 'btn-big': big, 'btn-to-action': toAction, 'btn-last': last}\"\n  [disabled]=\"disabled\">\n  <i *ngIf=\"icon\" class=\"fa fa-{{icon}}\" [ngClass]=\"{'icon-left' : label}\"></i>\n  <span *ngIf=\"label\"> {{ label | uppercase }} </span>\n  <i *ngIf=\"toAction\" class=\"fa fa-chevron-right icon-right\" [ngClass]=\"{'btn-last-icon': last}\"></i>\n</button>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/button/button.component.html
// module id = 1090
// module chunks = 0